import { render, staticRenderFns } from "./ChangeAccess.vue?vue&type=template&id=2a207e06"
import script from "./ChangeAccess.vue?vue&type=script&lang=js"
export * from "./ChangeAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports